import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { gql, useMutation } from '@apollo/client';
import { getClient } from '../client';
export var CREATE_PROFESSOR = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation createProfessor(\n    $professor: ProfessorProfileInput!\n  ) {\n    createProfessor(\n      professor: $professor\n    )\n  }\n"])));
export var UPDATE_PROFESSOR = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  mutation updateProfessor(\n    $professor: ProfessorProfileInput!\n  ) {\n    updateProfessor(\n      professor: $professor\n    )\n  }\n"])));

/**
 * Create/Update Professor Profile
 * @param operation defaults to 'CREATE' or you can choose from 'CREATE' | 'UPDATE'
 * @returns Mutation Tuple
 */
export var useProfessorProfile = function useProfessorProfile() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'CREATE';
  var client = getClient();
  return useMutation(operation === 'CREATE' ? CREATE_PROFESSOR : UPDATE_PROFESSOR, process.env.JEST_WORKER_ID === undefined ?
  /* istanbul ignore next */
  {
    client: client
  } : {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-plat-ui/utils/dist/esm/hooks/professorProfile.js
// module id = 5774
// module chunks = 11